import Layout from "./components/Layout";
import Finish from "./components/Finish";

export default function Success(){

    return (
        <Layout>

            <Finish />

        </Layout>
    );
}